"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SqsQueueNames = void 0;
var SqsQueueNames;
(function (SqsQueueNames) {
    SqsQueueNames["AutomationQueue"] = "AutomationQueue";
    SqsQueueNames["CoreQueue"] = "CoreQueue";
    SqsQueueNames["GenericModelChangeQueue"] = "GenericModelChangeQueue";
    SqsQueueNames["NotificationJobs"] = "NotificationJobs";
    SqsQueueNames["PaymentsJobs"] = "PaymentsJobs";
    SqsQueueNames["PimsEtlOnboardingIntegrationSync"] = "PimsEtlOnboardingIntegrationSync";
    SqsQueueNames["PimsEtlOnboardingIntegrationModelSync"] = "PimsEtlOnboardingIntegrationModelSync";
    SqsQueueNames["PimsEtlOnboardingModelDataSync"] = "PimsEtlOnboardingModelDataSync";
    SqsQueueNames["PimsEtlOnboardingModelChanges"] = "PimsEtlOnboardingModelChanges";
    SqsQueueNames["PimsEtlOnboardingRetryModelChanges"] = "PimsEtlOnboardingRetryModelChanges";
    SqsQueueNames["PimsEtlOnboardingIntegrationSyncPaged"] = "PimsEtlOnboardingIntegrationSyncPaged";
    SqsQueueNames["PimsEtlRealtimeIntegrationSyncPaged"] = "PimsEtlRealtimeIntegrationSyncPaged";
    SqsQueueNames["PimsEtlOnboardingBatchIntegrationSync"] = "PimsEtlOnboardingBatchIntegrationSync";
    SqsQueueNames["PimsEtlIntegrationSync"] = "PimsEtlIntegrationSync";
    SqsQueueNames["PimsEtlModelDataSync"] = "PimsEtlModelDataSync";
    SqsQueueNames["PimsEtlModelChanges"] = "PimsEtlModelChanges";
    SqsQueueNames["PimsEtlBatchIntegrationSync"] = "PimsEtlBatchIntegrationSync";
    SqsQueueNames["PimsEtlRetryModelChanges"] = "PimsEtlRetryModelChanges";
    SqsQueueNames["PimsEtlSyncJobs"] = "PimsSyncJobs";
    SqsQueueNames["PimsEtlSyncVetJobs"] = "PimsEtlSyncVetJobs";
    SqsQueueNames["PimsEtlSyncVetModelChanges"] = "PimsEtlSyncVetModelChanges";
    SqsQueueNames["PimsEtlSyncVetS3TriggerJobs"] = "PimsEtlSyncVetS3TriggerJobs";
    SqsQueueNames["PimsEtlSyncVetIntegrationModelSync"] = "PimsEtlSyncVetIntegrationModelSync";
    SqsQueueNames["RealTimeGenericModelChangeQueue"] = "RealTimeGenericModelChangeQueue";
    SqsQueueNames["SearchIndexing"] = "search-indexing";
    SqsQueueNames["SearchIndexingPimsCreate"] = "search-indexing_pims-create";
    SqsQueueNames["SearchJobs"] = "SearchJobs";
    SqsQueueNames["LoyaltyProgram"] = "LoyaltyProgram";
    SqsQueueNames["MediaJobs"] = "MediaJobs";
    SqsQueueNames["ConditionEngineJobs"] = "ConditionEngineJobs";
    SqsQueueNames["EmailCampaignEmailSend"] = "EmailCampaignEmailSend";
    SqsQueueNames["PimsWriteback"] = "PimsWriteback";
    SqsQueueNames["InformJobs"] = "InformJobs";
    SqsQueueNames["InformPartnerIntegrationRequestJobs"] = "InformPartnerIntegrationRequestJobs";
    SqsQueueNames["InformCampaignJobs"] = "InformCampaignJobs";
})(SqsQueueNames || (SqsQueueNames = {}));
exports.SqsQueueNames = SqsQueueNames;
//# sourceMappingURL=SqsQueueNames.js.map